import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationState } from './notification.reducer';

export const selectNotificationState = createFeatureSelector<NotificationState>('notification');

export const selectAllNotifications = createSelector(
  selectNotificationState,
  (state) => state.notifications
);

export const selectUnreadNotifications = createSelector(
  selectNotificationState,
  (state) => state.notifications.filter(n => !n.isRead)
);

export const selectNotificationLoading = createSelector(
  selectNotificationState,
  (state) => state.loading
);

export const selectNotificationError = createSelector(
  selectNotificationState,
  (state) => state.error
);
